import { render, staticRenderFns } from "./channelpopup.vue?vue&type=template&id=3b87e623&scoped=true"
import script from "./channelpopup.vue?vue&type=script&lang=js"
export * from "./channelpopup.vue?vue&type=script&lang=js"
import style0 from "./channelpopup.vue?vue&type=style&index=0&id=3b87e623&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b87e623",
  null
  
)

export default component.exports